module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-01.c1f6b5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-01.jpg
// module id = X14J
// module chunks = 1